module.exports = __webpack_public_path__ + "img/top3.1a9bd676.png";